import { createEffect, createEvent, sample } from 'effector'

import { type Language, langSelected } from '@/shared/lib/i18n'
import { createHideFx } from '@/shared/ui/modal'

export const showFx = createEffect<void, string>()
export const hideFx = createHideFx(showFx)

export const languageClicked = createEvent<Language>()

sample({
    clock: languageClicked,
    target: hideFx,
})

sample({
    clock: languageClicked,
    target: langSelected,
})
